import script from "./ClerkSignin.vue?vue&type=script&setup=true&lang=js"
export * from "./ClerkSignin.vue?vue&type=script&setup=true&lang=js"

import "./ClerkSignin.vue?vue&type=style&index=0&id=4a5c260e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4a5c260e"]])

export default __exports__